import script from "./ApiIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiIcon.vue?vue&type=script&setup=true&lang=js"

import "./ApiIcon.vue?vue&type=style&index=0&id=381f20aa&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381f20aa"]])

export default __exports__